import React from 'react';
import PropTypes from 'prop-types';
import useAutoOpenCardPickerModal from '@/hooks/useAutoOpenCardPickerModal';
import InlineCardCalloutNotification from './InlineCardCalloutNotification';

const AutoOpeningInlineCardCalloutNotification = ({ className }) => {
  useAutoOpenCardPickerModal();

  return <InlineCardCalloutNotification className={className} />;
};

AutoOpeningInlineCardCalloutNotification.propTypes = {
  className: PropTypes.string,
};

export default AutoOpeningInlineCardCalloutNotification;
